import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

const fetchData = async () => {
    const { data } = await axios.get('/api/geographicTargeting/token');
    return data;
};

const useMapTokenQuery = () => {
    return useQuery({
        queryKey: ['mapToken'],
        queryFn: () => fetchData(),
        staleTime: Infinity,
        enabled: true,
    });
};

export { useMapTokenQuery };
